/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChargingDataDto } from '../models/charging-data-dto';
import { CommandDto } from '../models/command-dto';
import { exchangeStatusForCommandPost$Json } from '../fn/chardi/exchange-status-for-command-post-json';
import { ExchangeStatusForCommandPost$Json$Params } from '../fn/chardi/exchange-status-for-command-post-json';
import { exchangeStatusForCommandPost$Plain } from '../fn/chardi/exchange-status-for-command-post-plain';
import { ExchangeStatusForCommandPost$Plain$Params } from '../fn/chardi/exchange-status-for-command-post-plain';
import { getChargingDataListGet$Json } from '../fn/chardi/get-charging-data-list-get-json';
import { GetChargingDataListGet$Json$Params } from '../fn/chardi/get-charging-data-list-get-json';
import { getChargingDataListGet$Plain } from '../fn/chardi/get-charging-data-list-get-plain';
import { GetChargingDataListGet$Plain$Params } from '../fn/chardi/get-charging-data-list-get-plain';
import { loginPost$Json } from '../fn/chardi/login-post-json';
import { LoginPost$Json$Params } from '../fn/chardi/login-post-json';
import { loginPost$Plain } from '../fn/chardi/login-post-plain';
import { LoginPost$Plain$Params } from '../fn/chardi/login-post-plain';
import { sendCommandPost } from '../fn/chardi/send-command-post';
import { SendCommandPost$Params } from '../fn/chardi/send-command-post';
import { stopAllCommandPost } from '../fn/chardi/stop-all-command-post';
import { StopAllCommandPost$Params } from '../fn/chardi/stop-all-command-post';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class ChardiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `loginPost()` */
  static readonly LoginPostPath = '/Login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginPost$Plain$Response(params?: LoginPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return loginPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginPost$Plain(params?: LoginPost$Plain$Params, context?: HttpContext): Observable<User> {
    return this.loginPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginPost$Json$Response(params?: LoginPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return loginPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginPost$Json(params?: LoginPost$Json$Params, context?: HttpContext): Observable<User> {
    return this.loginPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /** Path part for operation `getChargingDataListGet()` */
  static readonly GetChargingDataListGetPath = '/GetChargingDataList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargingDataListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargingDataListGet$Plain$Response(params?: GetChargingDataListGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargingDataDto>>> {
    return getChargingDataListGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargingDataListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargingDataListGet$Plain(params?: GetChargingDataListGet$Plain$Params, context?: HttpContext): Observable<Array<ChargingDataDto>> {
    return this.getChargingDataListGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChargingDataDto>>): Array<ChargingDataDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargingDataListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargingDataListGet$Json$Response(params?: GetChargingDataListGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargingDataDto>>> {
    return getChargingDataListGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargingDataListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargingDataListGet$Json(params?: GetChargingDataListGet$Json$Params, context?: HttpContext): Observable<Array<ChargingDataDto>> {
    return this.getChargingDataListGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChargingDataDto>>): Array<ChargingDataDto> => r.body)
    );
  }

  /** Path part for operation `sendCommandPost()` */
  static readonly SendCommandPostPath = '/SendCommand';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendCommandPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendCommandPost$Response(params?: SendCommandPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendCommandPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendCommandPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendCommandPost(params?: SendCommandPost$Params, context?: HttpContext): Observable<void> {
    return this.sendCommandPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `stopAllCommandPost()` */
  static readonly StopAllCommandPostPath = '/StopAllCommand';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stopAllCommandPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  stopAllCommandPost$Response(params?: StopAllCommandPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return stopAllCommandPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stopAllCommandPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stopAllCommandPost(params?: StopAllCommandPost$Params, context?: HttpContext): Observable<void> {
    return this.stopAllCommandPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exchangeStatusForCommandPost()` */
  static readonly ExchangeStatusForCommandPostPath = '/ExchangeStatusForCommand';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exchangeStatusForCommandPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exchangeStatusForCommandPost$Plain$Response(params?: ExchangeStatusForCommandPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CommandDto>> {
    return exchangeStatusForCommandPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exchangeStatusForCommandPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exchangeStatusForCommandPost$Plain(params?: ExchangeStatusForCommandPost$Plain$Params, context?: HttpContext): Observable<CommandDto> {
    return this.exchangeStatusForCommandPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommandDto>): CommandDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exchangeStatusForCommandPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exchangeStatusForCommandPost$Json$Response(params?: ExchangeStatusForCommandPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CommandDto>> {
    return exchangeStatusForCommandPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exchangeStatusForCommandPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exchangeStatusForCommandPost$Json(params?: ExchangeStatusForCommandPost$Json$Params, context?: HttpContext): Observable<CommandDto> {
    return this.exchangeStatusForCommandPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommandDto>): CommandDto => r.body)
    );
  }

}
